import React from 'react'
import Link from 'gatsby-link'
import styles from './FAQ.module.scss'
import marked from 'marked'

const FAQ = props => (
	<div className={styles.FAQ} id="faq">
		<h2 className="h2">{props.title}</h2>
		{props.items.map((item, i) => (
			<div className={styles.FAQ__Item} key={i}>
				<p>{item.question}</p>
				<p dangerouslySetInnerHTML={{ __html: marked(item.answer.answer) }} />
			</div>
		))}
		<Link to={props.link.link} className="hoverlink">
			{props.link.text}
		</Link>
	</div>
)

export default FAQ



// WEBPACK FOOTER //
// ./src/components/Program/FAQ/index.js